module.exports = __webpack_public_path__ + "15_scivis.pdf?03eecf73f80fe3cb29197751d3af6281";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_scivis.pdf
// module id = 147
// module chunks = 0